import React, { lazy, Suspense } from 'react';

const LazyAddRole = lazy(() => import('./AddRole'));

const AddRole = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyAddRole {...props} />
  </Suspense>
);

export default AddRole;
